import { MODULES, type ModuleId } from '@tahi/core';
import { createStore } from './store';

export interface ConnectionStep {
  moduleId: ModuleId;
  name: string;
  detail?: string;
}

export interface ConnectionToastData {
  id: number;
  headline: string;
  steps: ConnectionStep[];
}

export const connectionStore = createStore<ConnectionToastData | null>(null);
let seq = 0;

/** Shows "Logged · Quit Smoking ┄ Spending ₱12.00 ┄ Budget" (design.md connection toast). */
export function showConnection(
  headline: string,
  chain: ModuleId[],
  details: Partial<Record<ModuleId, string>> = {},
): void {
  connectionStore.set({
    id: ++seq,
    headline,
    steps: chain.map((m) => ({ moduleId: m, name: MODULES[m]?.name ?? m, detail: details[m] })),
  });
}

export function dismissConnection(): void {
  connectionStore.set(null);
}

export function connectionSummary(t: ConnectionToastData): string {
  return `${t.headline} · ${t.steps.map((s) => (s.detail ? `${s.name} ${s.detail}` : s.name)).join(' ┄ ')}`;
}
